import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Loader from "./../utilityComponents/Loader";
import { AuthError } from "./errorComponents";
import PropTypes from "prop-types";
import Navbar from "../components/Navbar";
import LocTok from "./uTk";

export function requireAuthentication(NavCompStatus, ChildComponent, urlToCheck) {
    class CheckAccess extends React.Component {
        constructor() {
            super();
            this.state = {
                loading: true,
                login_page: false,
            };
            this.defaultMsg = {
                error: "",
                errorResponse: "",
                privilegeError: false,
            };
        }
        _redirectToHomePage() {
            this.props.history.push(`/close_loop`);
        }
        componentWillMount() {
            let login_page = urlToCheck == "/" ? true : false;
            let storedTk = new LocTok();
            if (!storedTk.isLocTokValid()) {
                if (login_page) {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.defaultMsg,
                            loading: false,
                            error: false,
                        };
                    });
                } else {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.defaultMsg,
                            loading: false,
                            error: true,
                            errorResponse: {
                                response: {
                                    data: {
                                        message: "User Not Authenticated, Please Login!.",
                                    },
                                    status: 401,
                                },
                            },
                        };
                    });
                }
            } else {
                let data = {
                    url: urlToCheck,
                };
                axios
                    .post("/api/user/check_access", data)
                    .then((response) => {
                        if (response.data.message == "Authenticated") {
                            if (urlToCheck == "/") {
                                this._redirectToHomePage();
                            } else {
                                this.setState((prevState) => {
                                    return {
                                        ...prevState,
                                        ...this.defaultMsg,
                                        loading: false,
                                        error: false,
                                    };
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error.response);
                        if (urlToCheck == "/") {
                            this.setState((prevState) => {
                                return {
                                    ...prevState,
                                    ...this.defaultMsg,
                                    loading: false,
                                    error: false,
                                };
                            });
                        } else {
                            console.log(error.response);
                            // if(error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
                            //     && error.response.data.hasOwnProperty("message")){
                            if (
                                Object.prototype.hasOwnProperty.call(error, "response") &&
                                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                                Object.prototype.hasOwnProperty.call(error.response.data, "message")
                            ) {
                                if (
                                    error.response.data.message !=
                                    "Sorry!, You do not have enough privileges to access the page/request."
                                ) {
                                    let url = "/api/user/logout";
                                    let data = {};
                                    axios
                                        .post(url)
                                        .then((response) => {
                                            console.log(response);
                                            this.setState((prevState) => {
                                                return {
                                                    ...prevState,
                                                    ...this.defaultMsg,
                                                    loading: false,
                                                    error: true,
                                                    errorResponse: error,
                                                };
                                            });
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            this.setState((prevState) => {
                                                return {
                                                    ...prevState,
                                                    ...this.defaultMsg,
                                                    loading: false,
                                                    error: true,
                                                    errorResponse: error,
                                                };
                                            });
                                        });
                                } else {
                                    this.setState((prevState) => {
                                        return {
                                            ...prevState,
                                            ...this.defaultMsg,
                                            loading: false,
                                            privilegeError: true,
                                            error: true,
                                            errorResponse: error,
                                        };
                                    });
                                }
                            } else {
                                this.setState((prevState) => {
                                    return {
                                        ...prevState,
                                        ...this.defaultMsg,
                                        loading: false,
                                        error: true,
                                        errorResponse: {
                                            response: {
                                                data: {
                                                    message:
                                                        "Something Went Wrong, Please Login Again!.",
                                                },
                                                status: 500,
                                            },
                                        },
                                    };
                                });
                            }
                        }
                    });
            }
        }

        render() {
            let render_template = null;
            if (this.state.error) {
                render_template = (
                    <AuthError
                        errorResponse={this.state.errorResponse}
                        history={this.props.history}
                        privilegeError={this.state.privilegeError}
                    />
                );
            } else {
                render_template = (
                    <React.Fragment>
                        {NavCompStatus == "NavBarReq" ? <Navbar /> : null}
                        <ChildComponent {...this.props} />
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment>{this.state.loading ? <Loader /> : render_template}</React.Fragment>
            );
        }
    }

    CheckAccess.propTypes = {
        history: PropTypes.string,
    };

    CheckAccess.defaultProps = {
        history: [],
    };

    const mapStateToProps = (state) => {
        return state;
    };

    return withRouter(CheckAccess);
}
